// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'nickname',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'email',
    Object: 'value',
    label: '',
    width: '120'
  }, {
    prop: 'phone_number',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'merchant_name',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'merchant_address',
    label: '',
    Object: 'value',
    width: '180'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
